import { waitForCSRF } from '../utils/generic-utilities.es6';
import { safeGTMuaEventsPusher } from '../utils/gtm-utilities.es6';

const get3DModelDetails = () => {
    return waitForCSRF(() => fetch(`${window.location.pathname}/product-3d-model.json`));
};

const getStyleID = moduleElement => moduleElement.querySelector('.product-3d-view-cta').getAttribute('data-product-style-id');

const bootStrap3DModel = (uid, { overlay, moduleElement }) => {
    const VIEWER_READY = 'viewerready';
    const CAMERA_STOP = 'camerastop';
    const iframe = overlay.querySelector('iframe');
    const client = new window.Sketchfab(iframe);
    const TURN_OFF = 0;
    const TURN_ON = 1;
    const ALWAYS_SHOW = 2;

    client.init(uid, {
        api_log: TURN_OFF,
        double_click: TURN_OFF,
        ui_animations: TURN_OFF,
        ui_annotations: TURN_OFF,
        ui_color: '1b1b1b',
        ui_fullscreen: TURN_OFF,
        ui_help: TURN_OFF,
        ui_hint: ALWAYS_SHOW,
        ui_infos: TURN_OFF,
        ui_inspector: TURN_OFF,
        ui_settings: TURN_OFF,
        ui_stop: TURN_OFF,
        ui_vr: TURN_OFF,
        ui_watermark: TURN_OFF,
        ui_ar: TURN_ON,
        camera: TURN_OFF,

        success: api => {
            let initialCamera;
            let isOriginalView = true;
            api.start();

            const handleCameraStop = () => {
                api.addEventListener(CAMERA_STOP, () => {
                    if (isOriginalView === false) {
                        overlay.querySelector('.reset').classList.remove('hide');
                    }

                    isOriginalView = false;
                });
            };

            const setOriginalView = (duration = 3) => {
                if (initialCamera) {
                    api.setCameraLookAt(initialCamera.position, initialCamera.target, duration);
                }
                isOriginalView = true;
                overlay.querySelector('.reset').classList.add('hide');
            };

            api.addEventListener(VIEWER_READY, () => {
                api.recenterCamera(() => {
                    overlay.querySelector('.loading').classList.add('hide');
                    overlay.querySelector('.thumbnail').classList.add('hide');
                    api.getCameraLookAt((err, camera) => {
                        initialCamera = camera;
                        handleCameraStop();
                    });
                });
            });

            overlay.querySelector('.close').addEventListener('click', () => {
                setOriginalView(0);
                overlay.classList.add('hide');
                safeGTMuaEventsPusher('interactionEvent', 'product page', '3D click close', getStyleID(moduleElement));
                document.body.classList.remove('overlay-open');
            });

            overlay.querySelector('.reset').addEventListener('click', () => {
                setOriginalView();
                safeGTMuaEventsPusher('interactionEvent', 'product page', '3D click on original view', getStyleID(moduleElement));
            });
        },
        error: e => {
            throw e;
        }
    });
};

const initialize3DView = ({ uid, thumbnailUrl }, elements) => {
    document.body.appendChild(elements.overlay);
    let isInitialized = false;
    if (uid) {
        elements.moduleElement.classList.remove('hide');
        elements.view3Dbutton.addEventListener('click', () => {
            safeGTMuaEventsPusher('interactionEvent', 'product page', '3D click on view in 3D', getStyleID(elements.moduleElement));

            elements.overlay.classList.remove('hide');
            document.body.classList.add('overlay-open');
            if (isInitialized === false) {
                isInitialized = true;
                elements.overlay.querySelector('.thumbnail').setAttribute('src', thumbnailUrl || '');
                bootStrap3DModel(uid, elements);
            }
        });
    }
};

// eslint-disable-next-line no-unused-vars
const initialize = moduleElement => {
    const elements = {
        moduleElement,
        overlay: moduleElement.querySelector('.product-3d-view-overlay'),
        view3Dbutton: moduleElement.querySelector('.product-3d-view-cta')
    };
    get3DModelDetails()
        .then(response => response.json())
        .then(product3dObject => {
            initialize3DView(product3dObject, elements);
        })
        .catch(e => {
            throw e;
        });
};

export const load = () => {
    // document.querySelectorAll('.product-3d-view').forEach(moduleElement => initialize(moduleElement));
};
